import { Settings } from './settings.js'

export var SessionState = {
    storage: sessionStorage,    //replace this with localStorage, if you want to keep the state across sessions
    set: function (cat, param, value) {
        if (!this.storage || !param) return;
        cat = cat || "app";
        var key = Settings.appPrefix + cat + "_" + param;
        if (typeof(value) === "undefined" || value === null) {
            this.storage.removeItem(key);
        }
        else {
            this.storage.setItem(key, value);
        }
    },
    get: function (cat, param) {
        if (!this.storage || !param) return null;
        cat = cat || "app";
        var key = Settings.appPrefix + cat + "_" + param;
        
        return this.storage.getItem(key);
    },
    clear: function () {
        if (!this.storage) return;
        this.storage.clear();
    }
}